export const isObject = value => {
  return typeof value === 'object' && value !== null;
};

export const someValuesTruthy = object => Object.values(object).some(v => v);

export const isNullish = value => {
  return value === null || value === undefined;
};

export const isNaNish = value => {
  return value === null || value === undefined || isNaN(value);
};
